import { Alert, ListItem, List, Typography, Box } from '@mui/material';
import { useLocalization } from '../../providers/LocalizationProvider';

function FormWarnings({ warnings = [] }) {
  const { dynamicMessage } = useLocalization();
  if (!warnings || (Array.isArray(warnings) && warnings?.length === 0)) {
    return null;
  }
  let currentWarnings = [];
  if (Array.isArray(warnings)) {
    currentWarnings = warnings;
  } else if (typeof warnings === 'object') {
    currentWarnings = [warnings];
  } else {
    currentWarnings = [{ message: JSON.stringify(warnings) }];
  }

  if (currentWarnings && currentWarnings.length > 0) {
    return (
      <Alert sx={{ mb: 2, mt: -1 }} severity="warning">
        <Box>
          <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
            {dynamicMessage('Warnings')}
          </Typography>
        </Box>
        <List sx={{ listStyleType: 'disc', pl: 2, pt: 0.1 }}>
          {currentWarnings.map((warning, index) => {
            return (
              <ListItem
                key={warning?.message || index}
                sx={{
                  display: 'list-item',
                  pl: 0,
                  m: 0,
                  py: 0,
                }}>
                <Typography variant="body">{warning?.message}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Alert>
    );
  }
  return null;
}

export default FormWarnings;
